import { FC } from 'react'
import { OfficeHeader } from 'components'
import { ReportingTab } from './tabs'

type Props = {}


const ProductionReportsPage: FC<Props> = (props) => {
    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <OfficeHeader />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  p-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    <ReportingTab />
                </div>
            </div>
        </main>
    )
}

export default ProductionReportsPage